import { Navigate, createHashRouter } from 'react-router';
import ErrorPage from '../../app/ErrorPage';
import Root from '../../app/Root';
import PrayerSettingPage from '../components/prayerSetting/pages/PrayerSettingPage';
import CustomizingPage from '../components/customizing/pages/CustomizingPage';
import CustomizingTimeTable from '../components/customizing/CustomizingTimeTable';
import PrinterPage from '../components/customizing/pages/PrinterPage';
import LocationPage from '../components/customizing/pages/LocationPage';
import HijraPage from '../components/hijra/pages/HijraPage';
import Welcome from '../components/welcome/Welcome';
import SidebarDoc from '../components/Docs/page/SidebarDoc';
import SinglePrayerDoc from '../components/Docs/SinglePrayerDoc';
import PrayerTimeDoc from '../components/Docs/TimeTableDoc';
import DocPage from '../components/Docs/page/DocPage';
import TimeTableDoc from '../components/Docs/TimeTableDoc';
import HomeDocs from '../components/Docs/HomeDocs';
import MorePage from '../components/More/page/MorePage';
import TranslationComponent from '../components/More/translates/PrayerNamesEditor';
import PrayerNamesEditor from '../components/More/translates/PrayerNamesEditor';
import GregorianMonthsEditor from '../components/More/translates/GregorianMonthsEditor';
import GregorianNumbersEditor from '../components/More/translates/GregorianNumbersEditor';
import HijraMonthsEditor from '../components/More/translates/HijraMonthsEditor';
import HijraNumbersEditor from '../components/More/translates/HijraNumbersEditor';
import Timetable_Prayer from '../components/More/translates/Timetable_Prayer';
import Vertical_Daily_Prayer from '../components/More/translates/Vertical_Daily_Prayer';
import WelcomeSettingsNotice from '../components/More/page/WelcomeSettingsNotice';
import ExtraInfo from '../components/More/translates/ExtraInfo';
export const CustomRouter = createHashRouter([
	{
		path: '/',
		element: <Root />,
		errorElement: <ErrorPage />,
		children: [
			{
				index: true,
				element: <Welcome />,
			},
			{
				path: "prayersettings",
				element: <PrayerSettingPage />,
			},

			{
				path: 'customizing',
				element: <CustomizingPage />,
				children: [
					{
						index: true,
						element: <Navigate to={'timetable'} replace />,
					},
					{
						path: 'timetable',
						element: <CustomizingTimeTable />,
					},

					{
						path: 'printerpage',
						element: <PrinterPage />,
					},
					{
						path: 'location',
						element: <LocationPage />,
					},
				],
			},
			{
				path: 'hijra',
				element: <HijraPage />,
			},

			{
				path: 'moresettings',
				element: <MorePage />,
				children: [
					{
						index: true,
						element: <WelcomeSettingsNotice />,
					},
					{
						path: 'translate/prayernames',
						element: <PrayerNamesEditor />
					},
					{
						path: 'translate/timetableprayer',
						element: <Timetable_Prayer />
					},
					{
						path: 'translate/verticaldailyprayer',
						element: <Vertical_Daily_Prayer />
					},
					{
						path: 'translate/hijramonths',
						element: <HijraMonthsEditor />
					},
					{
						path: 'translate/hijranumbers',
						element: <HijraNumbersEditor />
					},
					{
						path: 'translate/gregorianmonths',
						element: <GregorianMonthsEditor />
					},
					{
						path: 'translate/gregoriannumbers',
						element: <GregorianNumbersEditor />
					},
					{
						path: 'translate/extra_info',
						element: <ExtraInfo />
					},

				]
			},
			{
				path: 'documentation',
				element: <DocPage />,
				children: [


					{
						index: true,
						element: <HomeDocs />,
					},
					{
						path: 'singleprayer/shortcodes',
						element: <SinglePrayerDoc />
					},
					{
						path: 'singleprayer/blocks',
						element: <h1>blocks component</h1>
					},
					{
						path: 'timetable/shortcodes',
						element: <TimeTableDoc />
					},
					{
						path: 'timetable/blocks',
						element: <h1>Blocks component</h1>
					},
				],
			},
		],
	},
],
	{
		future:{
			unstable_middleware: true
		}
	}
);
